module.exports = __webpack_public_path__ + "static/media/hp-home-banner-tablet-@2x.39574b7e.jpg";